import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEnvelope } from "react-icons/fa";

export default function ForgotPasswordSuccessPage() {
  const navigate = useNavigate();

  const Icon = FaEnvelope as React.FC<React.SVGProps<SVGSVGElement>>;

  // countdown in seconds (60 min = 3600 seconds)
  const [timeLeft, setTimeLeft] = useState(1800);

  // convert seconds to mm:ss format
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-lg text-center">
        <span className="mx-auto text-blue-600 text-5xl mb-6 animate-bounce flex justify-center">
          <Icon />
        </span>


        <h1 className="text-2xl font-semibold mb-4">Check Your Email</h1>
        <p className="text-gray-600 mb-4">
          If an account exists for the email you provided, a password reset link has been sent.
          Please check your inbox (and spam folder) to continue.
        </p>
        <div className="flex items-center justify-center gap-2 mb-6">
          <span className="text-sm text-gray-500">Link expires in</span>
          <span className="font-semibold text-blue-600 text-lg">
            {formatTime(timeLeft)}
          </span>
        </div>
        <p className="text-gray-500 text-sm mb-6">
          Didn’t receive the email? You can try again or contact our support team.
        </p>
        <button
          onClick={() => navigate("/login")}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg transition"
        >
          Back to Login
        </button>
      </div>
    </div>
  );
}
